module.exports = __webpack_public_path__ + "media/organizations/UniversitatDerKunste-df444e16.webp";